<template>
  <div class="flex justify-center py-10 print:hidden">
    <paginate
      v-model="page"
      :page-count="pageCount"
      :page-range="pageRange"
      :margin-pages="2"
      :click-handler="clickCallback"
      :prev-text="`<i class='fa fa-chevron-left text-xs'></i>`"
      :next-text="`<i class='fa fa-chevron-right text-xs'></i>`"
      :container-class="'flex flex-wrap items-center justify-center gap-2 list-none m-0 p-0'"
      :page-class="'group'"
      :page-link-class="'flex items-center justify-center w-10 h-10 rounded-lg border border-gray-200 bg-white text-gray-500 font-medium transition-all duration-200 hover:border-[#4CAF50] hover:text-[#4CAF50] hover:shadow-md hover:-translate-y-0.5 focus:outline-none cursor-pointer'"
      :prev-class="'mr-2'"
      :prev-link-class="'flex items-center justify-center w-10 h-10 rounded-lg border border-gray-200 bg-white text-gray-400 transition-all duration-200 hover:bg-gray-50 hover:text-[#4CAF50] hover:border-[#4CAF50] hover:shadow-sm cursor-pointer'"
      :next-class="'ml-2'"
      :next-link-class="'flex items-center justify-center w-10 h-10 rounded-lg border border-gray-200 bg-white text-gray-400 transition-all duration-200 hover:bg-gray-50 hover:text-[#4CAF50] hover:border-[#4CAF50] hover:shadow-sm cursor-pointer'"
      :active-class="'pagination-active'"
      :disabled-class="'opacity-40 cursor-not-allowed pointer-events-none grayscale'"
      :break-view-link-class="'flex items-center justify-center w-10 h-10 rounded-lg text-gray-400 tracking-widest'"
      class="pagination-main">
    </paginate>
  </div>
</template>

<script setup>
import Paginate from "vuejs-paginate-next";
import { useWindowScroll, useWindowSize } from "@vueuse/core";
import { useFilterStore } from "~/store/FilterStore";

const props = defineProps(["pageCount"]);
const pageRange = ref(10)

const { width, height } = useWindowSize()

const filterStore = useFilterStore()
const { y } = useWindowScroll({ behavior: 'smooth' });
// const page = computed(() => filterStore.page) //ref(1);
const page = useState('page-num',()=>1);
const clickCallback = (pageNum) => {
  // filterStore.setPage(+pageNum)
  page.value = +pageNum;
  setTimeout(() => {
    if (y.value > 0) y.value = 0;
  }, 500);
  // EventBus.emit("paginate", pageNum);
};
// const setPage = (pageNum = 1) => {
//   page.value = +pageNum;
// };
// const offHandleSetPage = EventBus.on("set-page", (val) => {
//   setPage(val);
// });

// onBeforeUnmount(() => {
//   offHandleSetPage(); // Use the returned off function to unregister this specific listener
// });
onMounted(()=>{
  if (height.value <= 650 && width.value <= 768) {
    pageRange.value = 4
  }
})
</script>
<style scoped>
/* Deep selector to target the active link inside the active list item */
:deep(.pagination-active a) {
  background-color: #4CAF50 !important;
  border-color: #4CAF50 !important;
  color: white !important;
  box-shadow: 0 4px 10px rgba(76, 175, 80, 0.35);
  transform: translateY(-2px);
  font-weight: 600;
}
</style>
